<template>
  <b-modal :active.sync="active"
      has-modal-card full-screen :can-cancel="false" class="has-overflow">
    <div class="modal-card">
        <header class="modal-card-head">
          <div class="columns is-centered" style="width: 100%">
            <div class="column is-half">
              <p class="modal-card-title">{{ eventId ? 'Editar Evaluación' : 'Nueva Evaluación' }}</p>
            </div>
          </div>
        </header>
        <section class="modal-card-body">
          <ValidationObserver ref="observer">
          <div class="columns is-centered" style="width: 100%">
            <div class="column is-half">
          <b-field>
            <ValidationProvider
                  name="Nombre"
                  :rules="'required'"
                  v-slot="{ errors }">
              <b-field label="Nombre"
                label-position="inside"
                :type="{ 'is-danger': errors[0] }"
                :message="errors">
                <b-input
                    type="text"
                    v-model="event.name"
                    placeholder="Nombre Evaluación">
                </b-input>
              </b-field>
            </ValidationProvider>
          </b-field>
          <b-field label="Ubicación"
            label-position="inside">
            <location-selector :value="locationName" @select="locationSelected = $event"/>
          </b-field>
          <b-field grouped>
            <b-field expanded>
              <ValidationProvider
                name="Fecha Inicio"
                :rules="'required'"
                v-slot="{ errors }">
                <b-field label="Fecha Inicio"
                label-position="inside"
                :type="{ 'is-danger': errors[0] }"
                :message="errors">
                  <b-datepicker
                        placeholder="Selecciona una fecha"
                        v-model="startDate"
                        :first-day-of-week="1"
                        :month-names="$moment.months()"
                        :day-names="$moment.weekdaysShort()"
                        :unselectable-days-of-week="[0]"
                        :mobile-native="false"
                        :max-date="endDate"
                        expanded>
                        <button class="button is-danger"
                            @click="startDate = null">
                            <b-icon icon="close"></b-icon>
                            <span>Limpiar</span>
                        </button>
                  </b-datepicker>
                </b-field>
              </ValidationProvider>
            </b-field>
            <b-field expanded>
              <ValidationProvider
                name="Fecha Termino"
                :rules="''"
                v-slot="{ errors }">
                <b-field label="Fecha Termino"
                label-position="inside"
                :type="{ 'is-danger': errors[0] }"
                :message="errors">
                  <b-datepicker
                        placeholder="Selecciona una fecha"
                        v-model="endDate"
                        :first-day-of-week="1"
                        :month-names="$moment.months()"
                        :day-names="$moment.weekdaysShort()"
                        :unselectable-days-of-week="[0]"
                        :mobile-native="false"
                        :min-date="startDate"
                        :focused-date="endDate ? endDate : startDate"
                        expanded>
                        <button class="button is-danger"
                            @click="endDate = null">
                            <b-icon icon="close"></b-icon>
                            <span>Limpiar</span>
                        </button>
                  </b-datepicker>
                </b-field>
              </ValidationProvider>
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field>
              <ValidationProvider
                    name="Hora de Inicio"
                    :rules="'required'"
                    v-slot="{ errors }">
                <b-field label="Hora de Inicio"
                  label-position="inside"
                  :type="{ 'is-danger': errors[0] }"
                  :message="errors"
                  expanded>
                  <b-timepicker
                      placeholder="Seleccione un hora"
                      icon="clock"
                      hour-format="24"
                      v-model="startAt"
                      :max-time="endAt"
                      editable>
                  </b-timepicker>
                </b-field>
              </ValidationProvider>
            </b-field>
            <b-field label="Hora de Termino"
              label-position="inside" expanded>
              <b-timepicker
                  placeholder="Seleccione un hora"
                  icon="clock"
                  hour-format="24"
                  v-model="endAt"
                  :min-time="startAt"
                  editable>
              </b-timepicker>
            </b-field>
          </b-field>
          <b-field label="Descripción"
            label-position="inside">
            <b-input
                rows="1"
                v-model="event.description"
                type="textarea"
                placeholder="Descripción de la evaluación">
            </b-input>
          </b-field>
            </div>
          </div>
          </ValidationObserver>
        </section>
        <footer class="modal-card-foot">
          <div class="columns is-centered" style="width: 100%">
            <div class="column is-half">
              <div class="columns">
                <div class="column">
                  <b-button expanded @click="cancel" :disabled="isLoading">Cancelar</b-button>
                </div>
                <div class="column">
                  <b-button type="is-primary" expanded @click="save" :loading="isLoading">Guardar</b-button>
                </div>
              </div>
            </div>
          </div>
        </footer>
      <b-loading :active.sync="loadingEvent" :is-full-page="false"></b-loading>
    </div>
  </b-modal>
</template>

<script>
import LocationSelector from '@/components/LocationSelector'
import EventService from '@/services/EventService'
import CredentialsService from '@/services/CredentialsService'

export default {
  components: {
    LocationSelector
  },
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    eventId: {
      required: false,
      default: null
    }
  },
  created () {
    if (this.eventId) {
      this.loadEvent()
    }
  },
  data () {
    return {
      isLoading: false,
      startDate: null,
      startAt: null,
      endDate: null,
      endAt: null,
      locationSelected: null,
      locationName: null,
      loadingEvent: false,
      event: {
        description: null,
        end_at: null,
        end_date: null,
        event_status_id: 1,
        event_type_id: 1,
        location_id: null,
        name: null,
        start_at: null,
        start_date: null,
        user_id: null
      }
    }
  },
  methods: {
    cancel () {
      this.initData()
      this.$emit('update:eventId', null)
      this.$emit('update:active', false)
    },
    success (text) {
      this.$buefy.toast.open({
        message: text,
        type: 'is-success'
      })
    },
    error () {
      this.$buefy.toast.open({
        message: 'No se pudo realizar los cambios',
        type: 'is-danger'
      })
    },
    initData () {
      this.startDate = null
      this.startAt = null
      this.endDate = null
      this.endAt = null
      this.locationSelected = null
      this.locationName = null
      this.event = {
        description: null,
        end_at: null,
        end_date: null,
        event_status_id: 1,
        event_type_id: 1,
        location_id: null,
        name: null,
        start_at: null,
        start_date: null,
        user_id: this.userId
      }
    },
    async loadEvent () {
      try {
        this.loadingEvent = true
        let params = {
          'include[1]': 'location'
        }
        let response = await EventService.getEvent(this.eventId, params)
        let event = response.data.data
        if (event) {
          this.startDate = event.start_date ? this.$moment(event.start_date, 'DD-MM-YYYY').toDate() : null
          this.endDate = event.end_date ? this.$moment(event.end_date, 'DD-MM-YYYY').toDate() : null
          this.startAt = event.start_at ? this.$moment(event.start_at, 'HH:mm').toDate() : null
          this.endAt = event.end_at ? this.$moment(event.end_at, 'HH:mm').toDate() : null
          this.locationSelected = event.location ? event.location : null
          this.locationName = event.location ? event.location.name : null
          this.event = event
        }
        this.loadingEvent = false
      } catch (error) {
        console.log(error)
      }
    },
    async save () {
      if (await this.$refs.observer.validate()) {
        this.isLoading = true

        try {
          let response = null
          let text = ''
          this.event.user_id = this.userId

          if (this.eventId) {
            response = await EventService.updateEvent(this.eventId, this.event)
            text = 'Evento editado exitosamente'
          } else {
            response = await EventService.createEvent(this.event)
            text = 'Servicio creado exitosamente'
          }

          if (response.status >= 200 && response.status < 300) {
            this.success(text)
            this.$emit('saved')
          } else {
            this.error()
          }
        } catch (error) {
          console.log(error)
          this.error()
        }
        this.initData()
        this.isLoading = false
        this.$emit('update:active', false)
        this.$emit('update:eventId', null)
      }
    }
  },
  watch: {
    startDate (value) {
      this.event.start_date = value ? this.$moment(value).format('YYYY-MM-DD') : null
    },
    endDate (value) {
      this.event.end_date = value ? this.$moment(value).format('YYYY-MM-DD') : null
    },
    startAt (value) {
      this.event.start_at = value ? this.$moment(value).format('HH:mm') : null
    },
    endAt (value) {
      this.event.end_at = value ? this.$moment(value).format('HH:mm') : null
    },
    locationSelected (value) {
      this.event.location_id = value ? value.id : null
    },
    eventId (value) {
      if (value) {
        this.loadEvent()
      }
    }
  },
  computed: {
    userId () {
      return CredentialsService.getUser().id
    }
  }
}
</script>
